<template>
<div>
	<vue-form v-on:submit="saveDetails" :working="statusWorking" :readonly="readonly" :save-button-fixed="true">

		<collapsible-panel :always-open="true" panel-size="md">
			<template slot="panel">
				<panel-menu 
					:menu-items="projectDetailSections"
					:active-item="activeSection"
					v-on:itemClick="activateSection">
				</panel-menu>
			</template>
			<template slot="main">
				<div class="container">
					<div>
						<div class="float-right mb-2" v-if="$store.project">
							<button v-if="!$store.project.date_completed && $store.project.archived == 1" class="btn btn-light" type="button" v-on:click="completeJob">
								<i class="fa fa-check-square"></i>
								Mark Project as Complete
							</button>
							<button
								v-if="!$store.project.date_completed && hasRejectedBid && $store.project.archived == 0"
								class="btn btn-light ml-2"
								type="button"
								v-on:click="archiveJob">
								<i class="fa fa-archive"></i> Archive Project
							</button>
							<template v-else-if="$store.project.archived == 0" >
								<button class="btn btn-light" type="button" v-on:click="completeJob">
									<template v-if="!$store.project.date_completed">
										<i class="fa fa-check-square"></i>
										Mark Project as Complete
									</template>
									<template v-else>
										<i class="fa fa-undo"></i>
										Mark Project as Incomplete
									</template>
								</button>
								<button class="btn btn-light" type="button" v-on:click="archiveJob">
									<i class="fa fa-archive"></i> Archive Project
								</button>
							</template>
							<button v-if="$store.project.archived == 1" class="btn btn-light" type="button" v-on:click="archiveJob">
								<i class="fa fa-archive"></i> Un-Archive Project
							</button>

						</div>
					</div>
					<div style="clear: both;"></div>
					<template v-if="activeSection == 'Details'">
						<widget class="form">

							<h3>Project Details</h3>

							<div v-if="$store.project.created_at" class="text-muted">
								Created @ {{ formatDateTimeToLocal($store.project.created_at) }}
							</div>

							<div v-if="$store.project.UpdatedBy" class="text-muted">
								Last edited by {{ $store.project.UpdatedBy.first_name }} {{ $store.project.UpdatedBy.last_name }} @ {{ formatDateTimeToLocal($store.project.updated_at) }}
							</div>

							<div style="clear: both;"></div>

							<template v-if="$store.company.CompanySetting">
								<field v-if="$route.params.id != 'new'" 
									label="Project #" 
									col-class="col-md-3 col-lg-2" 
									v-model="$store.project.job_num" 
									v-on:change="autoSaveDetails"
									:readonly="readonly || $store.company.CompanySetting.editable_job_nums == 0">
								</field>
							</template>

							<field label="Project Name" 
								col-class="col-md-3 col-lg-2" 
								v-model="$store.project.job_name" 
								:invalid="$store.errorList.job_name" 
								v-on:change="autoSaveDetails"
								:readonly="readonly">
							</field>

							<field label="Project Description" 
								col-class="col-md-3 col-lg-2" 
								v-model="$store.project.description"  
								v-on:change="autoSaveDetails"
								:params="{type: 'textarea'}" 
								:readonly="readonly">
							</field>

							<form-group v-if="hasWonBid"
								label="Is a bid"
								col-class="col-md-3 col-lg-2">

								<div class="text-success d-flex align-items-center mt-1"> 
									<i class="fa fa-award fa-2x text-success mr-2"></i>
									Bid Won
								</div>

							</form-group>
							
							<field v-else
								label="Is a bid"
								col-class="col-md-3 col-lg-2"
								v-model="$store.project.is_lead" 
								v-on:change="autoSaveDetails"
								:params="{type:'boolean'}"
								:readonly="bidToggleReadonly">

							</field>

							<field v-if="$store.project.is_lead == 0"
								label="Date Awarded" 
								col-class="col-md-3 col-lg-2" 
								v-model="$store.project.date_landed" 
								:invalid="$store.errorList.date_landed" 
								v-on:change="autoSaveDetails"
								:params="{type: 'date'}" 
								:readonly="readonly">
							</field>

							<field
								label="Start Date" 
								col-class="col-md-3 col-lg-2" 
								v-model="$store.project.start_date" 
								:invalid="$store.errorList.start_date" 
								v-on:change="autoSaveDetails"
								:params="{type: 'date'}" 
								:readonly="readonly">
							</field>

							<field label="Bonded" 
								col-class="col-md-3 col-lg-2" 
								v-model="$store.project.is_bonded"  
								v-on:change="autoSaveDetails"
								:params="{type: 'boolean'}" 
								:readonly="readonly">
							</field>

							<field label="Permit Required" 
								col-class="col-md-3 col-lg-2" 
								v-model="$store.project.permit_needed"  
								v-on:change="autoSaveDetails"
								:params="{type: 'boolean'}" 
								:readonly="readonly">
							</field>

							<template v-if="$store.project.permit_needed == 1">

								<div class="row">
									<div class="col-md-6 col-sm-12">
										<field label="Inspector Number" 
											col-class="col-5 col-sm-3 col-md-6 col-lg-4"  
											v-on:change="autoSaveDetails"
											v-model="$store.project.inspector_num" 
											 :readonly="readonly">
										</field>

										<field label="Inspector Name" 
											col-class="col-5 col-sm-3 col-md-6 col-lg-4"  
											v-on:change="autoSaveDetails"
											v-model="$store.project.inspector_name" 
											 :readonly="readonly">
										</field>
									</div>
									<div class="col-md-6 col-sm-12">
										<field label="Inspector Email" 
											col-class="col-5 col-sm-3 col-md-6 col-lg-4" 
											v-on:change="autoSaveDetails" 
											v-model="$store.project.inspector_email" 
											 :readonly="readonly">
										</field>

										<field label="Notification Number" 
											col-class="col-5 col-sm-3 col-md-6 col-lg-4" 
											v-model="$store.project.permit_notification_number" 
											 :readonly="readonly">
										</field>
									</div>
								</div>

							</template>

							<field label="Has Locates" 
								col-class="col-md-3 col-lg-2" 
								v-model="$store.project.has_locates" 
								:params="{type: 'boolean'}"  
								v-on:change="autoSaveDetails"
								:readonly="readonly">

								<p v-if="$store.project.has_locates == 1 && $route.params.id != 'new'" class="mt-1">
									<router-link to="locates">Go to locates...</router-link>
								</p>

							</field>

							<qbo-job-sync-alert v-if="qboIsActive"
								:job="$store.project"
								api-resource="Job"
								v-on:qboIdSet="$store.project.qbo_id = $event">		
							</qbo-job-sync-alert>
							
						</widget>
						
						<widget class="form">
							<h3>Categorization</h3>

							
							<field v-if="'Category' in $store.project && $store.project.Category && !fields.category.editMode" style="flex-grow: 1;margin-right: 10px;"
								label="Category" 
								col-class="col-md-3 col-lg-2" 
								:value="$store.project.Category.name"
								:params="{type:'editable-static', working: fields.category.working}"
								v-on:click="selectEditMode('category',fetchJobCategories)">
							</field>
							<template v-else>
								<field v-if="categoryOptions.length > 0"
									label="Category" 
									col-class="col-md-3 col-lg-2" 
									v-model="$store.project.category_id" 
									:params="{type: 'select', options: categoryOptions}" 
									:invalid="$store.errorList.category_id"
									:readonly="readonly">
								</field>
								<div v-else>
									Job Categories not set up yet. <router-link v-if="hasModulePermWrite('Settings') && hasModulePermWrite('Projects') && hasModulePermWrite('Services')" to="/settings/categories">Add some</router-link>
								</div>
							</template>

							<field v-if="'RevenueCode' in $store.project && $store.project.RevenueCode && !fields.revCode.editMode" style="flex-grow: 1;margin-right: 10px;"
								label="Revenue Code"
								col-class="col-md-3 col-lg-2"
								:value="$store.project.RevenueCode.code+': '+$store.project.RevenueCode.description"
								:params="{type:'editable-static', working: fields.revCode.working}"
								v-on:click="selectEditMode('revCode',fetchRevenueCodes)">
							</field>
							<template else>
								<field v-if="revenueCodeOptions.length > 0"
									label="Revenue Code" 
									col-class="col-md-3 col-lg-2" 
									v-model="$store.project.revenue_code_id" 
									:params="{type: 'select', options: revenueCodeOptions}" 
									:invalid="$store.errorList.revenue_code_id"
									:readonly="readonly">
								</field>
								<p v-else>Revenue codes not set up yet. <router-link v-if="hasModulePermWrite('Settings') && hasModulePermWrite('Projects') && hasModulePermWrite('Services')" to="/settings/revenue-codes">Add some</router-link></p>
							</template>
							
							
						</widget>
						
						<widget class="form">
							<h3>Customer & Contacts</h3>

							<label>
								<input type="checkbox" v-model="$store.project.is_internal_project" value="1">
								This is an internal project
							</label>

							<form-group v-if="$store.project.is_internal_project == 0 || !$store.project.is_internal_project" label="Customer" col-class="col-md-3 col-lg-2">

								<div :class="{'d-flex flex-wrap': fields.customer.editMode}">
									
									<template v-if="fields.customer.editMode || !('Customer' in $store.project) || !$store.project.Customer">
										<field style="flex-grow: 1;margin-right: 10px;"
											v-model="$store.project.customer_id" 
											v-on:change="updateCustomerInfo" 
											:params="{
												type: 'select', 
												options: $store.customerOptions
											}" 
											:readonly="readonly">
										</field>
										<div>
											<button v-if="!readonly && hasModulePermWrite('Contacts')" class="btn btn-light float-right" type="button" v-on:click="newCustomerModalVisible = true">
												<i class="fa fa-plus"></i>
												New Customer
											</button>
										</div>
									</template>
									
									<field v-else-if="'Customer' in $store.project && $store.project.Customer" style="flex-grow: 1;margin-right: 10px;"
										:value="$store.project.Customer.name"
										:params="{type:'editable-static', working: fields.customer.working}"
										v-on:click="selectEditMode('customer',fetchCustomers)">
									</field>
											
								</div>
							</form-group>

							<alert v-if="customer && customer.customer_onhold == 1"
								:visible="true"
								icon="fa-exclamation-triangle"
								classes="alert-warning pb-0"
								:unclosable="true">

								This customer has been placed on hold:

								<p><strong>Reason:</strong> {{customer.customer_onhold_reason ? customer.customer_onhold_reason : '[none specified]'}}</p>

							</alert>

							<contact-table
								:readonly="readonly"
								record-type="project" 
								:customer-id="$store.project.customer_id"
								:contacts="$store.project.JobContact" 
								:new-record="$route.params.id == 'new' ? true : false"
								:record-id="$store.project.id"
								v-on:contactAdded="fetchContacts"
								v-on:contactRemoved="fetchContacts">
							</contact-table>

							<field v-if="$store.project.is_internal_project == 0 || !$store.project.is_internal_project"
								label="Customer PO #" 
								col-class="col-md-3 col-lg-2" 
								v-model="$store.project.customer_po"  
								:readonly="readonly">
							</field>
						</widget>
					</template>
					<template v-else-if="activeSection == 'Site Location'">
					
						<widget class="form">
							<h3>Site Location</h3>

							<field 
								:params="{
									type: 'btn-group',
									buttons:[
										{text: 'Address',value:'address'},
										{text: 'Drag a Pin',value:'pin'}
									],
									disableNull:true
								}" 
								v-model="$store.project.location_type" 
								:readonly="readonly" :invalid="$store.errorList.location_type">

								<template v-if="$store.project.location_type == 'pin'">
									<div>Drag the pin to the location of the Project</div>

									<input v-if="$store.project.lat && $store.project.long" type="text" readonly class="form-control text-center" v-model="'Lat: '+ $store.project.lat + ' Long: ' + $store.project.long">

									<vue-map
										style="margin-bottom:10px;"
										key="drop-pin-map"
										:center="{
											lat: !isNaN(+$store.project.lat) ? +$store.project.lat : +$store.company.lat ? +$store.company.lat : 43,
											lng: !isNaN(+$store.project.long) ? +$store.project.long : +$store.company.long ? +$store.company.long : -79
										}"
										:zoom="7"
										map-size="map-sm"
										:markers="dropMarkers"
										v-on:markerDrop="setCoordsFromDroppedPin">
									</vue-map>
								</template>
								<div v-else class="row">

									<div v-if="mapsSrc" class="col-md-6">
										<div class="d-flex flex-column">
											<iframe
											  width="100%"
											  height="450"
											  frameborder="0" style="border:0"
											  sandbox="allow-scripts allow-same-origin"
											  :src="mapsSrc" allowfullscreen>
											</iframe>
											<button v-if="!showDirectionsOnMap" class="btn btn-light" style="width: 100%;" v-on:click="showDirectionsOnMap = true">
												<i class="fa fa-map"></i>
												Show Driving Directions
											</button>
										</div>
									</div>
									<div :class="{
											'col-md-6': mapsSrc,
											'col-md-12': !mapsSrc
										}">

										<address-manual-selector
											:suite="$store.project.suite"
											:address="$store.project.address"
											:city="$store.project.city"
											:province="$store.project.province"
											:country="$store.project.country"
											:postal-code="$store.project.postal_code"
											:readonly="readonly"
											v-on:input="updateLocation"
											:invalid-list="$store.errorList">
										</address-manual-selector>

									</div>

								</div>
							</field>
						</widget>
					</template>
					<template v-else-if="activeSection == 'Safety'">
						<widget>

							<h3>Safety</h3>

							<div class="row" v-if="mapsSrc">
								<div class="col-md-6">
									<!--<field label="Nearby Hospitals"
										col-class="col-md-4"
										:params="{type:'select',options:hospitalOptions}"
										v-on:change="hospitalSelected">
										<p class="text-muted">Select a nearby hospital (ranked by closest)</p>
									</field>

									<p v-if="hospitalOptions.length > 0" style="margin-top: -10px;"><small>Results not relevant? Add the address of a hospital manually below</small></p>-->

									<field label="Hospital Name"
										col-class="col-md-4"
										v-model="hospital_name">
									</field>
									<field label="Hospital Address"
										col-class="col-md-4"
										v-model="hospital_address">
									</field>
								</div>
								<div class="col-md-6">
									<iframe v-if="hospital_name"
									  width="100%"
									  height="250"
									  frameborder="0" style="border:0"
									  sandbox="allow-scripts allow-same-origin"
									  :src="hospitalMapSrc" allowfullscreen>
									</iframe>
								</div>
							</div>
							<p v-else class="text-muted">Set address first</p>

						</widget>
					</template>
					<template v-else-if="activeSection == 'Setup Options'">
						<widget class="form">
							<h3>Setup Options</h3>

							<field v-if="$store.payBoostOptions.length > 0"
								label="Pay Adjustments for Time Log" 
								col-class="col-lg-3 col-md-4 col-sm-6" 
								v-model="$store.project.payboost_ids" 
								:params="{type: 'select-multi', options: $store.payBoostOptions}" 
								:readonly="readonly">	
							</field>
							<div v-else class="d-flex align-items-center mb-2">
								Pay Adustments not set up yet. <router-link v-if="hasModulePermWrite('Settings') && hasModulePermWrite('Users')" to="/employees/settings/pay-adjustments">Add some</router-link>
							</div>		

							<field :label="checkinToleranceLabel" 
								col-class="col-lg-3 col-md-4 col-sm-6" 
								v-model="$store.project.check_in_tolerance" 
								:params="{type: 'select', options: checkinToleranceOptions}" 
								:readonly="readonly">		
							</field>

							<template v-for="(union,index) in $store.unions" v-if="$store.projectUnionCollectiveAgreements">

								<field :label="'Compensation Schedule for '+union.union_name" 
									col-class="col-lg-3 col-md-4 col-sm-6" 
									:params="{type: 'select', options: collectiveAgreementOptions(union.id)}" 
									v-model="$store.projectUnionCollectiveAgreements[union.id]" 
									:readonly="readonly">
								</field>

								<field
									v-if="union.id in $store.projectUnionCollectiveAgreements && $store.projectUnionCollectiveAgreements[union.id] && mileageZoneOptions(union.id, $store.projectUnionCollectiveAgreements[union.id]).length > 0 && $store.projectMileageZones && union.id in $store.projectMileageZones"
									:label="'Mileage Zone for '+union.union_name"
									col-class="col-lg-3 col-md-4 col-sm-6"
									:params="{type:'select',options:mileageZoneOptions(union.id, $store.projectUnionCollectiveAgreements[union.id])}"
									v-model="$store.projectMileageZones[union.id]"
									:readonly="readonly">
									<hr>
								</field>

							</template>

							<template v-if="$store.unions.length > 0">
								<field label="Mileage Pay" 
									col-class="col-lg-3 col-md-4 col-sm-6" 
									v-model="$store.project.pays_mileage" 
									:params="{type: 'boolean'}" 
									:readonly="readonly">		
								</field>

								<field label="Per Diem Pay" 
									col-class="col-lg-3 col-md-4 col-sm-6" 
									v-model="$store.project.pays_perdiem" 
									:params="{type: 'boolean'}" 
									:readonly="readonly">
								</field>
							</template>

							<field label="Detailed Time Logs"
								col-class="col-lg-3 col-md-4 col-sm-6"
								v-model="$store.project.detailed_timelogs"
								:params="{type:'boolean'}"
								:readonly="readonly">

								<p class="text-muted">If on, workers break down their hours at clock out. An active bid is broken down by bid section or component. With no bid, a detailed report is only required when they claim time to a change order.</p>

								<field v-if="$store.project.detailed_timelogs == 1"
									label="Detailed Time Log Reporting Level"
									col-class="col-md-6"
									v-model="$store.project.detailed_timelogs_depth"
									:params="{
										type:'select',
										options: [
											{
												text: 'Bid Categories',
												value: 0
											},
											{
												text: 'Top Level Bid Component',
												value: 1
											},
										]}"
									:readonly="readonly">
								</field>

							</field>
						</widget>
						
						<widget class="form">
							<h3>Access Control</h3>

							<p>Restrict this project from company wide access. Module based permissions over-ride the permissions that you set below.</p>

							<form-group label="Read Restricted" col-class="col-md-3 col-lg-2">
								<field v-model="$store.project.read_restricted" :params="{type: 'boolean'}" :readonly="readonly"></field>
								<p class="text-muted">If on, only personnel specifically assigned to a role with read permissions enabled in this project can <strong>read</strong> this project data.</p>
							</form-group>

							<form-group label="Write Restricted" col-class="col-md-3 col-lg-2">
								<field v-model="$store.project.write_restricted" :params="{type: 'boolean'}" :readonly="readonly"></field>
								<p class="text-muted">If on, only personnel specifically assigned to a role with write permissions enabled in this project can <strong>write</strong> this project data.</p>
							</form-group>

							<div v-if="$route.params.id != 'new'">
								<button v-if="$store.project.deleted == 0" type="button" class="btn btn-outline-danger" v-on:click="deleteJobModalVisible = true">
									<i class="fa fa-trash"></i> Delete Project
								</button>
							</div>

						</widget>
					</template>
					<template v-else-if="activeSection == 'Personnel'">

						<personnel-tab 
							v-on:fetchJob="$emit('fetchProject')" 
							:is-sub-component="true" 
							module="Jobs"
							store-location="project"
							job-type="Project"
							:key="$route.params.id">	
						</personnel-tab>

						<div class="alert alert-info">
							<p><strong>The following roles are required:</strong></p>
							<ul class="required-role-list">
								<li v-for="role in requiredRoleListProjects"><i class="fa" :class="hasRoleAssigned(role.id) ? 'fa-check' : 'fa-times'"></i> {{role.title}}</li>
							</ul>
						</div>

					</template>
					<section class="mt-3 mb-2 d-flex justify-content-between align-items-center">
						<div>
							<button v-if="activeSection != 'Details'" type="button" class="btn btn-light float-left" v-on:click="prevStep">
								<i class="fa fa-chevron-left"></i>
								Previous Step
							</button>
						</div>

						<div>
							<button v-if="projectDetailSections.findIndex(sec => sec == activeSection) < projectDetailSections.length - 1" type="button" class="btn btn-light" v-on:click="nextStep">
								Next Step
								<i class="fa fa-chevron-right"></i>
							</button>
						</div>
					</section>
				</div>
			</template>
		</collapsible-panel>
	</vue-form>

	<new-contact-modal
		:visible="newCustomerModalVisible"
		:is-customer="true"
		v-on:contactAdded="customerAdded"
		v-on:closeModal="newCustomerModalVisible = false">
	</new-contact-modal>

	<modal-dialog
		title="Delete Project"
		:modal-visible="deleteJobModalVisible"
		confirm-button-text="Yes, Delete"
		button-class="btn-outline-danger"
		v-on:closeModal="deleteJobModalVisible = false"
		v-on:confirm="deleteJob">

		Are you sure you want to delete this project?

	</modal-dialog>

	<modal-dialog
		title="Project Completion Date"
		:modal-visible="projectCompleteModal.visible"
		confirm-button-text="Save"
		:working="projectCompleteModal.working"
		v-on:closeModal="projectCompleteModal.visible = false"
		v-on:confirm="saveCompleteJob">

		<field label="Project Completion Date" col-class="col-md-6" :params="{type:'date'}" v-model="projectCompleteModal.payload.date_completed"></field>

	</modal-dialog>

	<modal-dialog
		title="Process Expenses and Archive Project"
		:modal-visible="processExpensesModal.visible"
		confirm-button-text="Yes, Process All Expenses & Archive"
		cancel-button-text="No"
		:working="processExpensesModal.working"
		v-on:closeModal="processExpensesModal.visible = false"
		v-on:confirm="confirmProcessAllExpenses">

		There are unprocessed expenses attached to this project -- would you like to mark all of them as processed and then archive the project?

	</modal-dialog>

</div>
</template>

<script>

import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"

import PanelMenu from "@/components/PanelMenu"
import VueForm from "@/components/VueForm"
import FormGroup from "@/components/FormGroup"
import Field from "@/components/Field"
import ModalDialog from "@/components/ModalDialog"
import TableList from "@/components/TableList"
import ContactTable from "@/components/super_components/ContactTable"
import NewContactModal from "@/components/super_components/NewContactModal"
import QboJobSyncAlert from "@/components/super_components/QboJobSyncAlert"
import Alert from "@/components/Alert"
import VueMap from "@/components/VueMap"
import PersonnelTab from '@/pages/project/PersonnelTab'

import AddressManualSelector from "@/components/AddressManualSelector"
import Widget from "@/components/Widget"

import JobMixins from "@/mixins/JobMixins.js"

export default {

	name: 'ProjectDetails',
	components: {
		CollapsiblePanel,
		PanelMenu,
		FormGroup,
		VueForm,
		Field,
		ModalDialog,
		TableList,
		ContactTable,
		NewContactModal,
		AddressManualSelector,
		Widget,
		QboJobSyncAlert,
		Alert,
		VueMap,
		PersonnelTab
	},
	mixins: [JobMixins],
	props: ["section"],
	data() {
		return {
			customer: {},
			projectPayBoosts: [],
			customerOptions: [],
			payBoostOptions: [],
			companies: [],
			statusWorking: false,
			readonly: false,
			deleteJobModalVisible: false,
			newCustomerModalVisible: false,
			projectCompleteModal: {
				visible: false,
				working: false,
				payload: {}
			},
			internalProject: 0,
			hospitals: [],
			hospital_name: "",
			hospital_address: "",
			editableStaticFields: [
				"customer",
				"category",
				"revCode"
			],
			activeSection: "Details",
			fields: {},
			mileageZones: {},
			defaultSettings: {},
			defaultsSet: false,
			showDirectionsOnMap: false,
			lastLatLongRequestAddress: {
				address: "",
				city: "",
				province: "",
				country: "",
				postal_code: ""
			},
			dropMarkers: [
				{
					lat: 43.5,
					lng: -79.5,
					draggable: true
				}
			],
			processExpensesModal: {
				visible: false
			}
		}
	},
	watch: {
		section() {
			this.setSection()
		},
		'$store.project.archived'() {
			if (this.$store.project.archived == 1)
				this.readonly = true
			else
				this.readonly = false
		},
		'$store.project'() {
			this.setHospitalFields()
			this.updatePinLocation()
		},
		/*'$store.project.address'() {
			//if address fiels are all filled out, and hospital list is empty, fetch hospitals
			if (this.$store.project.address && this.$store.project.city && this.$store.project.province)
				this.debounce('fetchHospitals',false,3000)
		},
		'$store.project.city'() {
			//if address fiels are all filled out, and hospital list is empty, fetch hospitals
			if (this.$store.project.address && this.$store.project.city && this.$store.project.province)
				this.debounce('fetchHospitals',false,3000)
		},*/
		'$store.project.lat'() {
			//if job location changes, we might need to pull fresh list of nearby hospitals

			/*
			let pullNeeded = true
			try {
				let hospitalObj = JSON.parse(this.$store.project.hospital_json)

				if (this.$store.project.lat == hospitalObj.job_lat && this.$store.project.long == hospitalObj.job_long) {
					pullNeeded = false

					this.hospitals = hospitalObj.hospitals
				}
			}
			catch (ex) {}

			if (pullNeeded)
				this.fetchHospitals()
			*/
		},
		'$store.company'() {
			if (!this.defaultsSet) 
				this.setDefaultValues()
		}
	},
	computed: {
		/*hospitalOptions() {

			if (this.hospitals) {
				return this.optionify(this.hospitals.map(hospital => {
					let address = ""
					if ("formatted_address" in hospital)
						address = hospital.formatted_address
					else if ("vicinity" in hospital)
						address = hospital.vicinity

					return {
						name: hospital.name + ": "+address,
						id: address
					}
				}),"name")
			}
			else
				return []
		},*/
		projectDetailSections() {
			
			if (this.isFreemiumUser) {
				return [
					"Details",
					"Site Location",
					"Personnel"
				]
			}
			else {
				return [
					"Details",
					"Site Location",
					"Safety",
					"Setup Options",
					"Personnel"
				]
			}
		},
		bidToggleReadonly() {
			return this.readonly || this.hasWonBid
		},
		hasWonBid() {
			if ("JobBid" in this.$store.project && this.$store.project.JobBid) {
				let activeAcceptedBid = this.$store.project.JobBid.find(bid => {
					return bid.is_active == 1 && bid.status == 'Accepted'
				})

				if (activeAcceptedBid)
					return true
			}
			return false
		},
		hasRejectedBid() {
			if (!this.$store.project || this.$store.project.is_lead != 1)
				return false
			if ("JobBid" in this.$store.project && this.$store.project.JobBid) {
				let activeRejectedBid = this.$store.project.JobBid.find(bid => {
					return bid.is_active == 1 && bid.status == 'Rejected'
				})
				if (activeRejectedBid)
					return true
			}
			return false
		},
		hospitalMapSrc() {
			return 'https://www.google.com/maps/embed/v1/directions?key='+this.$store.GoogleEmbedAPIkey+"&destination="+this.hospital_name+"+"+this.hospital_address+"&origin="+this.$store.project.lat+","+this.$store.project.long
		},
		mapsSrc() {

			if (!("address" in this.$store.project) || !("city" in this.$store.project) || !("province" in this.$store.project) || !("country" in this.$store.project) || !("postal_code" in this.$store.project))
				return false;

			let address_query = this.$store.project.address+"+"+this.$store.project.city+"+"+this.$store.project.province+"+"+this.$store.project.country+"+"+this.$store.project.postal_code

			if (this.$store.company && this.showDirectionsOnMap) {
				let office = this.$store.company.address+"+"+this.$store.company.city+"+"+this.$store.company.province+"+"+this.$store.company.country+"+"+this.$store.company.postal_code
				return 'https://www.google.com/maps/embed/v1/directions?key='+this.$store.GoogleEmbedAPIkey+"&destination="+address_query+"&origin="+office
			}
			else 
				return 'https://www.google.com/maps/embed/v1/place?key='+this.$store.GoogleEmbedAPIkey+"&q="+address_query
			
		}
	},
	methods: {
		setDefaultValues() {

			this.defaultSettings = {}
			try {
				this.defaultSettings = JSON.parse(this.$store.company.CompanySetting.job_defaults_json)
			}
			catch (e) {}

			let keys = [
				"write_restricted",
				"read_restricted",
				"pays_perdiem",
				"pays_mileage",
				"check_in_tolerance",
				"payboost_ids"
			]

			let vm = this

			keys.forEach(key => {
				if (key in vm.defaultSettings)
					vm.$store.project[key] = vm.defaultSettings[key]
			})

			this.$store.projectMileageZones = this.defaultSettings.mileage_zones

			vm.defaultsSet = true
		},
		setSection() {
			if (this.section) {
				//match it by lower case
				let matchingIndex = this.projectDetailSections.findIndex(section => section.toLowerCase() == this.section.toLowerCase())

				if (matchingIndex >= 0) 
					this.activeSection = this.projectDetailSections[matchingIndex]
				
			}
		},	
		setCoordsFromDroppedPin(position,marker) {

			this.$set(this.$store.project,"lat",Math.round(position.lat*100000)/100000)
			this.$set(this.$store.project,"long",Math.round(position.lng*100000)/100000)

			marker.lat = position.lat
			marker.lng = position.lng
		},
		activateSection(section) {
			this.activeSection = section
		},
		prevStep() {
			//find index of current and minus one
			this.activeSection = this.projectDetailSections[this.projectDetailSections.indexOf(this.activeSection)-1]
		},
		nextStep() {
			//find index of current and minus one
			this.activeSection = this.projectDetailSections[this.projectDetailSections.indexOf(this.activeSection)+1]

			if (this.activeSection == 'Personnel')
				this.saveDetails()
		},
		selectEditMode(field,fetchFunction) {
			let vm = this

			this.fields[field].working = true

			fetchFunction().then(response => {
				vm.fields[field].editMode = true
				vm.fields[field].working = false
			})
		},
		updatePinLocation() {
			this.dropMarkers = []

			let lat, long
			if (this.$store.project && "lat" in this.$store.project && "long" in this.$store.project) {
				lat = +this.$store.project.lat
				long = +this.$store.project.long			
			}

			if (!lat)
				lat = +this.$store.company.lat
			if (!long)
				long = +this.$store.company.long

			this.dropMarkers.push({
				lat,
				lng: long,
				draggable: true
			})
		},
		resetEditMode(field) {
			this.fields[field].working = false
			this.fields[field].editMode = false
		},
		resetAllEditModes() {
			let vm = this
			this.editableStaticFields.forEach(field => {
				vm.resetEditMode(field)
			})
		},
		setHospitalFields() {
			try {
				let hospital = JSON.parse(this.$store.project.hospital_json)

				if ("selected" in hospital) {
					this.hospital_name = hospital.selected.name
					this.hospital_address = hospital.selected.formatted_address
				}
				else {
					if ("name" in hospital)
						this.hospital_name = hospital.name
					if ("address" in hospital)
						this.hospital_address = hospital.address
				}
				this.hospitals = hospital.hospitals
			}
			catch (ex) {}
		},
		updateLocation(address) {
			let vm = this

			Object.keys(address).forEach((key,index) => {
				vm.$set(vm.$store.project,key,address[key])
			})

			vm.autoSaveDetails()

			//this.debounce('fetchHospitals',false,5000)
		},
		hospitalSelected(value) {
			let hospital = this.hospitals.find(hospital => hospital.vicinity == value)

			if (hospital) {
				this.$store.project.hospital_json = JSON.stringify({
					job_lat: this.$store.project.lat,
					job_long: this.$store.project.long,
					selected: hospital,
					hospitals: this.hospitals
				})

				this.hospital_name = hospital.name
				this.hospital_address = hospital.vicinity
			}
		},
		updateCustomerInfo(customer_id) {
			let vm = this

			let customer = this.$store.customers.filter(cust => {
				if (cust.id == customer_id)
					return true
			})[0]

			vm.customer = customer
		},
		setLastLatLongAddress() {
			let vm = this
			let fields = ["address","city","province","country","postal_code"]

			fields.forEach(field => {
				if (field in vm.$store.project)
					vm.lastLatLongRequestAddress[field] = vm.$store.project[field]
			})
		},
		lastLatLongRequestAddressMatchesProject() {
			let vm = this
			let fields = ["address","city","province","country","postal_code"]

			let theyMatch = true
			fields.forEach(field => {
				if (!(field in vm.$store.project) || vm.lastLatLongRequestAddress[field] != vm.$store.project[field])
					theyMatch = false
			}) 

			return theyMatch
		},
		customerAdded(response) {
			let vm = this
			this.newCustomerModalVisible = false

			//refresh list
			this.fetchCustomers().then(customerResponse => {
				vm.$store.project.customer_id = response.data.record_id
				vm.$forceUpdate()
			})
		},
		deleteJob() {
			let vm = this

			this.postData("Job/delete",{id:this.$store.project.id}).then(response => {
				vm.deleteJobModalVisible = false

				//remove from projects lists
				let projectIndex = vm.$store.projects.findIndex(job => job.id == vm.$store.project.id)
				vm.$store.projects.splice(projectIndex,1)
				
				projectIndex = vm.$store.lastListedProjects.findIndex(job => job.id == vm.$store.project.id)
				vm.$store.lastListedProjects.splice(projectIndex,1)

				vm.$nextTick(() => {
					vm.$router.push("/projects")
				})
			})
		},
		completeJob() {
			if (this.$store.project.date_completed) {
				let vm = this

				this.saveRecord("Job",{id: this.$store.project.id,date_completed: null},response => {
					vm.alertSuccess("Project reverted to incomplete")
					vm.$store.project.date_completed = null
				})
			}
			else {
				this.projectCompleteModal.visible = true
				this.projectCompleteModal.payload = {
					id: this.$store.project.id,
					date_completed: this.moment().format("YYYY-MM-DD")
				}
			}
		},
		saveCompleteJob() {
			let vm = this

			this.projectCompleteModal.working = true

			this.saveRecord("Job",this.projectCompleteModal.payload,response => {
				vm.projectCompleteModal.visible = false
				vm.projectCompleteModal.working = false

				vm.$store.project.date_completed = vm.projectCompleteModal.payload.date_completed

				vm.projectCompleteModal.payload = {}

				vm.alertSaved("Project marked complete")
			})
		},
		archiveJob() {
			let vm = this

			let archived = 0;
			if (this.$store.project.archived == 0)
				archived = 1

			return new Promise((resolve,reject) => {
				vm.postData("Job/save",{id: this.$store.project.id, archived: archived}).then(response => {
					if (response.success) 
						vm.$store.project.archived = archived
					else if (!response.success && "errors" in response) {
						if (response.errors.indexOf("Can't archive, there are unprocessed expenses attached to it") >= 0) {
							//offer to submit all logs and then archive the project
							vm.processExpensesModal.visible = true
						}
						else
							vm.alertErrors(response.errors)
					}
					resolve(response)
				})
			})

		},
		confirmProcessAllExpenses() {
			let vm = this

			this.processExpensesModal.working = true

			//fetch all the unprocessed expenses on this project
			let params = {
				filters: [
					["job_id",this.$store.project.id],
					["processed",0]
				]
			}
			this.getJSON("Expense/get",params).then(response => {
				if (response.success) {
					let payload = {
						records: JSON.stringify(response.data.map(exp => {
							return {
								id: exp.id,
								processed: 1,
								skipQBOPush: true
							}
						}))
					}

					vm.postData("Expense/save-batch",payload,true).then(response => {
						vm.processExpensesModal.working = false

						if (response.success) {
							vm.archiveJob().then(response => {
								if (response.success)
									vm.processExpensesModal.visible = false
							})
						}
					})
				}
			})
		},
		autoSaveDetails() {
			let vm = this

			this.$forceUpdate(() => {

				//check that required fields are filled, then autosave if they are
				let fields = [
					"job_name","address","city","province","country","check_in_tolerance","revenue_code_id","date_landed","start_date"
				]

				let fieldUnfilled = false
				fields.forEach(key => {
					if (!(key in vm.$store.project) || !vm.$store.project[key])
						fieldUnfilled = true
				})

				if (!fieldUnfilled) 
					vm.saveDetails()

			})
			
		},
		saveDetails() {
			let vm = this

			if ("PayBoost" in this.$store.project && this.$store.project.PayBoost) {
				let preservedPayBoost = this.$store.project.PayBoost
				this.$store.project.PayBoost = this.primitize(this.$store.project.PayBoost)
			}

			let payload = JSON.parse(JSON.stringify(this.$store.project))

			delete payload.Tenant
			delete payload.Customer
			delete payload.User
			delete payload.UpdatedBy
			delete payload.archived
			delete payload.ActiveSafetyForms
			delete payload.Category
			delete payload.JobContact
			delete payload.Contact
			delete payload.RevenueCode
			delete payload.JobPersonnelRole
			delete payload.JobFile

			if (this.$store.project.location_type == 'pin') {
				delete payload.address
				delete payload.city
				delete payload.suite
				delete payload.province
				delete payload.postal_code
			}
			else {
				delete payload.lat
				delete payload.long
			}

			payload.PayBoost = this.$store.project.payboost_ids

			if (this.$store.project.is_internal_project == 1)
				payload.is_internal_project = 1
			else
				payload.is_internal_project = 0

			/*payload.CollectiveAgreement = {
				'set': [],
				other_field: 'union_id',
				other_id: 
			}*/

			payload.collective_agreements_json = JSON.stringify(this.$store.projectUnionCollectiveAgreements)

			payload.mileage_zones_json = JSON.stringify(this.$store.projectMileageZones)

			delete payload.payboost_ids

			if (this.hospital_name || this.hospital_address) {
				let hospitalObj = {}
				try {
					hospitalObj = JSON.parse(payload.hospital_json)
				}
				catch (e) {}

				hospitalObj.name = this.hospital_name
				hospitalObj.address = this.hospital_address
				payload.hospital_json = JSON.stringify(hospitalObj)
			}

			if (this.$route.params.id == "new") {

				//separate out jobcontacts and save them separately after we get an id
				let JobContacts = this.$store.project.JobContact

				delete this.$store.project.JobContact

				this.saveRecord("Job",payload,response => {
					vm.resetAllEditModes()

					//update saved values on project object
					Object.keys(payload).forEach(key => {
						vm.$store.project[key] = payload[key]
					})

					if (response.success) {

						//get project
						vm.fetchProject(true,response.slug).then(jobResponse => {
							let route = "/project/" + response.slug

							let tab = "details"
							if ("tab" in vm.$route.params) {
								tab = vm.$route.params.tab
								route += "/" + tab
							}

							if (vm.activeSection)
								route += "/" + vm.activeSection.toLowerCase()

							vm.$router.push(route)

							//window.history.replaceState({},"","/project/" + response.slug + "/" + tab)
						})

					}
				})
			}
			else {
				this.saveRecord("Job",payload,(response) => {
					vm.alertSaved("Project details saved")
					vm.resetAllEditModes()
					vm.$emit('fetchProject')
				})
			}
		},
		fetchContacts() {
			let vm = this

			let filter = JSON.stringify([
				["job_id",this.$store.project.id]
			])

			let include = JSON.stringify([{
				model: "Contact",
				include: ["Contact"]
			}])

			this.getJSON("JobContact/get?filters="+filter+"&include="+include).then(response => {
				vm.$store.project.JobContact = response.data
			})
		},
		/*fetchHospitals() {
			let vm = this

			if ("lat" in this.$store.project && this.$store.project.lat && "long" in this.$store.project && this.$store.project.long && vm.lastLatLongRequestAddressMatchesProject()) {
				this.fetchHospitalsPromise().then(response => {
					let responseObj = JSON.parse(response.data)
					vm.hospitals = responseObj.results
				})
			}
			else if ("address" in this.$store.project && "city" in this.$store.project && "province" in this.$store.project && "country" in this.$store.project && "postal_code" in this.$store.project || !vm.lastLatLongRequestAddressMatchesProject()) {

				//need to geocode first
				let fields = {
					key: this.$store.GoogleEmbedAPIkey,
					address: this.$store.project.address+"+"+this.$store.project.city+"+"+this.$store.project.province+"+"+this.$store.project.country+"+"+this.$store.project.postal_code
				}

				let params = {
					url: "https://maps.googleapis.com/maps/api/geocode/json",
					fields: JSON.stringify(fields)
				}

				this.getJSON("Proxy/request",params).then(response => {
					let responseObj = JSON.parse(response.data)

					if (responseObj.results.length > 0) {

						vm.$store.project.lat = responseObj.results[0].geometry.location.lat
						vm.$store.project.long = responseObj.results[0].geometry.location.lng

						vm.setLastLatLongAddress()

						vm.fetchHospitalsPromise().then(responseHospitals => {
							let responseObj = JSON.parse(responseHospitals.data)
							vm.hospitals = responseObj.results
						})
					}
				})
			}
		},
		fetchHospitalsPromise() {
			let vm = this

			let fields = {
				key: this.$store.GoogleEmbedAPIkey,
				keyword: 'urgent care',
				type: 'hospital',
				location: this.$store.project.lat+","+this.$store.project.long,
				rankby: "distance"
			}

			let params = {
				//url: "https://maps.googleapis.com/maps/api/place/textsearch/json",
				url: "https://maps.googleapis.com/maps/api/place/nearbysearch/json", //better search
				fields: JSON.stringify(fields)
			}

			return new Promise((resolve,reject) => {

				vm.getJSON("Proxy/request",params,true).then(response => {
					resolve(response)
				})
			})
		}*/
	},
	created() {
		let vm = this

		//set up editable static fields
		this.editableStaticFields.forEach(field => {
			vm.$set(this.fields,field,{
				working: false,
				editMode: false
			})
		})

		this.$store.project = {
			JobContact: [],
			is_lead: 0,
			location_type: 'address'
		}

		if ("CompanySetting" in this.$store.company && !this.defaultsSet)
			this.setDefaultValues()

		if (this.$route.params.id != "new") {
			this.$emit("fetchProject")

			if (this.$store.project.archived == 1)
				this.readonly = true
			else
				this.readonly = false
		}
		else {
			this.editableStaticFields.forEach(field => {
				vm.fields[field].editMode = true
			})
		}

		this.setSection()

		if (this.$store.customers.length == 0)
			this.fetchCustomers()

		if (this.$store.categories.length == 0)
			this.fetchJobCategories()

		if (this.$store.revenueCodes.length == 0)
			this.fetchRevenueCodes()

		this.updatePinLocation()

		/*if (this.$store.project.lat != 0)
			this.fetchHospitals()
		*/
	}

}
</script>

<style type="text/css">

@media (max-width: 500px) {
	h2 {
		font-size: 16pt;
		margin-bottom: 5px;
	}

}
</style>